import Flickity from 'flickity'; // https://flickity.metafizzy.co/

window.addEventListener('DOMContentLoaded', (event) => {
	const flickitySelector = '.wp-block-vs-carousel-block';
	const elementExists = document.querySelector(flickitySelector);

	if (document.body.contains(elementExists)) {
		const flkty = new Flickity('.wp-block-vs-carousel-block', {
			wrapAround: true,
			prevNextButtons: false,
		});
	}
});
